/**
 * VueInitialData Plugin
 *
 * Aids in loading context data via mixin in Vue, for instance loading
 * global data at runtime from window etc
 *
 * e.g. get window.VueInitialData.UserData in your component
 * //~~
 *  mounted() {
 *      let someData = this.getInitialData('UserData');
 *  }
 * ~~//
 */
export default {
    /**
     * @param Vue
     * @param options {
     *     dataScope : mixed data store, defaults to window
     *     dataKey : string top level key of the data store
     * }
     */
    install: function(app, options)
    {
        options = options || {};
        let dataScope = options.dataScope || window;
        let dataKey = options.dataKey || 'VueInitialData';
        let initialData = dataScope[dataKey] || {};
        app.mixin({
            methods: {
                getInitialData: function(key){
                    if (initialData[key] !== undefined) {
                        return initialData[key];
                    }
                }
            }
        });
    }
}